import React from 'react';
import {connect} from "react-redux";
import ProfileViewHeader from "./ProfileViewHeader";
import './profile-view.css'
import {Redirect} from "react-router-dom";
import ProfileViewContent from "./ProfileViewContent";

class ProfileViewContainer extends React.Component {

    render() {
        if (!this.props.profile.isLogin) return <Redirect to="/login"/>
        return (
            <>
                <ProfileViewHeader/>
                <ProfileViewContent profile={this.props.profile}/>
            </>
        )
    }
};
let mapStateToProps = (state) => {
    return {
        profile: state.profilePage
    }
}

export default connect(mapStateToProps, null)(ProfileViewContainer);